import React from 'react';
import { PlusIcon } from 'lucide-react';
import { SectionBadge } from '../SectionBadge';
import { Reveal } from '../Reveal';
import { FAQS } from '../../data/content';
export function Faq() {
  return <section className="w-full px-5 py-12 sm:py-16" data-id="element-58" data-mp="x422oxiw9ku2">
      <div className="mx-auto max-w-3xl" data-id="element-59" data-mp="x5mvoipk8vpt">
        <Reveal className="text-center" data-id="element-60" data-mp="1223i98h4320s">
          <SectionBadge data-id="element-61" data-mp="122vemlij93s4">Preguntas frecuentes</SectionBadge>
          <h2 className="mt-5 font-display text-2xl leading-tight text-snow sm:text-4xl" data-id="element-62" data-mp="1prxtjlls8iix">
            Todo lo que <span className="u-lime" data-id="element-63" data-mp="1urk8bzh9e6tu">querés saber</span>
          </h2>
        </Reveal>

        <div className="mt-8 space-y-2.5" data-id="element-64" data-mp="1g2xs7vjt5b1k">
          {FAQS.map((faq, index) => <Reveal key={faq.q} delay={Math.min(index, 3) * 60} data-id="element-65" data-mp="1g0jypr4s06w4" data-mpi={index}>
              <details className="group rounded-2xl border border-ink-line bg-ink" data-id="element-66" data-mp="1kzwlkbvnddyp">
                <summary className="flex cursor-pointer list-none items-center gap-4 p-4 focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-lime sm:p-5 [&::-webkit-details-marker]:hidden" data-id="element-67" data-mp="28q0mgbhgazm0">
                  <span className="flex-1 text-sm font-bold leading-snug text-snow sm:text-base" data-id="element-68" data-mp="2oqib7qwxrk7w">{faq.q}</span>
                  <PlusIcon className="h-4 w-4 flex-shrink-0 text-lime transition-transform duration-300 group-open:rotate-45" aria-hidden="true" data-id="element-69" data-mp="2jp1ca0y0i7ty" />
                </summary>
                <p className="px-4 pb-4 text-sm leading-relaxed text-snow-muted sm:px-5 sm:pb-5" data-id="element-70" data-mp="2tojvuga0frlh">{faq.a}</p>
              </details>
            </Reveal>)}
        </div>
      </div>
    </section>;
}